// removed by extract-text-webpack-plugin
module.exports = {"TransctionSearch-float":"TransctionSearch-float","TransctionSearchHeader":"TransctionSearchHeader","TransctionSearchInput":"TransctionSearchInput","TransctionSearchBtn":"TransctionSearchBtn"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Floats/TransactionSearchFloat/TransactionSearchFloat.scss
// module id = QPQA
// module chunks = 0